<template>
    <svg :fill="iconColor" :width="iconSize" :height="iconSize" id="icon_membership_status"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            d="M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z" />
    </svg>
</template>

<script>
export default {
    data() {
        return {
            iconColor: "#4CAF50",
            iconSize: "24px"
        };
    },
    mounted() {
        if (this.color)
            this.iconColor = this.getColor(this.color);
        if (this.size)
            this.iconSize = this.size;
    },
    props: ['color', 'size'],
    watch: {
        color: {
            handler: function (newValue) {
                if (newValue)
                    this.iconColor = this.getColor(newValue);
            }
        }
    }
};
</script>

<style>
svg {
    display: inline-block;
    vertical-align: baseline;
    margin-bottom: -6px;
}
</style>